/*       */

import { gql } from '@apollo/client';
import { digitalTwinShortQueryFields } from 'graphql/entities/classifications/classificationDetailQuery';

export const processesFields = `
    id
    name
    type
    primary(fields:["closedDate", "variables", "priority", "sequenceNumber"])
    processDefinitionVersion {
        iconName
        iconColor
        iconType
    }
`;

export default gql`
    query processesQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "process", filterBy: $filterBy, excludeBy: $excludeBy)
        records: processes(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${processesFields}
            primaryClass {
                ${digitalTwinShortQueryFields}
            }
            tasks { id }
            _wkt
            classes {
                id
                name
                uri
            }
            relations {
                isReverseRelation
            }
            workspaces {
                isSystem
                team { id }
                user { id }
            }
            modifiedDate
            createdDate
            createdBy {
                id
                name
                image
            }
            modifiedBy {
                id
                name
                image
            }
        }
    }
`;
